
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiver",
      function () {
        return require("private-next-pages/hiver.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiver"])
      });
    }
  